import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'cccisd-tooltip';
import style from './style.css';
import _get from 'lodash/get';

export default class TimePeriodDropdown extends React.Component {
    static propTypes = {
        label: PropTypes.node,
        field: PropTypes.object,
        options: PropTypes.array,
        onDomainsChange: PropTypes.func,
    };

    onCheckBoxChange = e => {
        const { field } = this.props;

        const checked = e.target.checked;
        if (checked) {
            field.onChange([...field.value, e.target.value]);
        } else {
            let uncheckedItem = e.target.value;
            const updatedItems = field.value.filter(item => {
                const itemName = _get(item, 'name', item);
                return itemName !== _get(uncheckedItem, 'name', uncheckedItem);
            });
            field.onChange(updatedItems);
        }
        this.props.onDomainsChange();
    };

    onCheckAllBoxChange = e => {
        const checked = e.target.checked;

        if (checked) {
            this.props.field.onChange(this.props.options.map(item => item.name));
        } else {
            this.props.field.onChange([]);
        }

        this.props.onDomainsChange();
    };

    getName = () => {
        const { label, field, options } = this.props;

        if (options.length === 0) {
            return 'No reporting periods found';
        }

        if (field.value.length === 0) {
            return `Select ${label}`;
        }

        if (field.value.length === 1) {
            const option = options.find(item => item.name === field.value[0]);
            if (option) {
                return option.name;
            }
        }

        return `${field.value.length} ${label}s`;
    };

    checkAllChecked = () => {
        const { field, options } = this.props;
        const optionNames = options.map(option => option.name);

        return field.value.length === optionNames.length;
    };

    render() {
        const { field, label, options } = this.props;

        return (
            <div>
                <div className="dropdown">
                    <button
                        type="button"
                        className={`btn btn-default dropdown-toggle ${style.button}`}
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="true"
                    >
                        <Tooltip title={this.getName()} placement="top">
                            <div className={style.buttonText}>
                                {this.getName()} <span className="caret" />
                            </div>
                        </Tooltip>
                    </button>

                    <ul className="dropdown-menu" style={{ padding: '0.5em', overflow: 'auto', width: '400px' }}>
                        {options.length === 0 ? (
                            <li>No reporting periods found</li>
                        ) : (
                            <form>
                                <li>
                                    <label className="dropdown-item">
                                        <div className={style.listItem}>
                                            <input
                                                type="checkbox"
                                                name="select-all"
                                                value="select-all"
                                                checked={this.checkAllChecked()}
                                                onChange={this.onCheckAllBoxChange}
                                            />
                                            <div>{`All ${label}s`}</div>
                                        </div>
                                    </label>
                                </li>
                                <li role="separator" className="divider" />
                                {options.map(option => (
                                    <li key={option.name}>
                                        <label className="dropdown-item">
                                            <div className={style.listItem}>
                                                <input
                                                    type="checkbox"
                                                    name={option.name}
                                                    value={_get(option, 'name', option)}
                                                    checked={field.value
                                                        .map(item => _get(item, 'name', item))
                                                        .includes(option.name)}
                                                    onChange={this.onCheckBoxChange}
                                                />
                                                <div>{option.name}</div>
                                            </div>
                                        </label>
                                    </li>
                                ))}
                            </form>
                        )}
                    </ul>
                </div>
            </div>
        );
    }
}
